export default "__VITE_ASSET__0w7syAGSRItZPv38NHpayA__"